<template>
  <div>
    <!-- <v-divider dark class="pb-2"></v-divider> -->
    <v-expansion-panels
      flat
      tile
      multiple
      :value="openAll(betDataMatchedPremium)"
      class="mt-0 pre-odds"
    >
      <v-expansion-panel
        v-for="(betDataPremium, premium) in betDataMatchedPremium"
        :key="betDataPremium.transactionId + premium"
        class="mt-0"
      >
        <v-expansion-panel-header class="py-0 px-4 caption align-self-stretch">
          <div>
            {{ betDataPremium.bets.length }}
            {{ betDataPremium.eventName }} -
            {{
              $moment(betDataPremium.createdAt).format('DD/MM/YYYY, h:mm:ss a')
            }}
            , Amount Placed :
            {{ betDataPremium.amount }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div
            v-for="(bet, ks) in betDataPremium.bets"
            :key="'bet.id' + ks"
            class="px-2 pt-2"
          >
            <div class="caption">
              {{ bet.event }}
            </div>
            <div class="caption px-2">
              {{ bet.sport_name }} / {{ bet.category_name }} /
              {{ bet.tournament_name }}
            </div>
            <div class="caption font-weight-bold px-2">
              {{ bet.odds }} -
              <span
                v-for="(runner, js) in bet.competitor_name"
                :key="'keyIndexs' + js"
                ><span v-if="js != 0"> V </span> {{ runner }}
              </span>
            </div>
            <div class="caption px-2">
              <div>{{ bet.market_name }} {{ bet.outcome_name }}</div>
            </div>
            <div class="caption px-2">
              Ticket Id : {{ betDataPremium.betslipId }}
            </div>
            <v-divider :key="'bet.id' + ks" class="mt-2"></v-divider>
          </div>
        </v-expansion-panel-content>
        <v-divider></v-divider>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: {
    betDataMatchedPremium: { type: Array, default: () => [], required: true }
  },
  methods: {
    openAll(v) {
      return [...v.keys()].map((k, i) => i)
    }
  }
}
</script>
<style lang="scss" scoped>
.pre-odds {
  .v-expansion-panel {
    border: none !important;
    border-radius: o !important;
  }
}
</style>
